'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class NavbarComponent {
  menu = [
    {
      title: 'HOME',
      state: 'main'
    },
    {
      title: '車両紹介',
      state: 'bus-list'
    },
    {
      title: 'サービス',
      state: 'service.strength'
    },
    {
      title: '会社情報',
      state: 'company.company-top'
    },
    {
      title: '求人情報',
      state: 'recruit'
    },
    {
      title: 'その他のビジネス',
      state: 'others'
    }
  ];

  isCollapsed = true;

  constructor($location) {
    'ngInject';

    this.$location = $location;
  }

  isActive(route) {
    return route === this.$location.path();
  }
}

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.html'),
    controller: NavbarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js